export default "assets/lib-logo.png";